import ApiService from "@/common/api.service";
import {
  FETCH_COEFFICIENT_READINESS_YEARLY,
  UPDATE_COEFFICIENT_READINESS
} from "../actions.type";
import {
  FETCH_COEFFICIENT_READINESS_START,
  SET_COEFFICIENT_READINESS_YEARLY
} from "../mutations.type";

const state = {
  coefficientReadiness: {
    monthly: [],
    yearly: [],
    isLoading: false
  }
};

const getters = {
  coefficientReadinessYearly: state => state.coefficientReadiness.yearly,
  coefficientReadinessIsLoading: state => state.coefficientReadiness.isLoading
};

const actions = {
  [FETCH_COEFFICIENT_READINESS_YEARLY](context, year) {
    context.commit(FETCH_COEFFICIENT_READINESS_START);
    return ApiService.get(`/coefficient/readiness/${year}`).then(
      ({ data }) => {
        context.commit(SET_COEFFICIENT_READINESS_YEARLY, data);
      }
    );
  },
  [UPDATE_COEFFICIENT_READINESS](context, payload) {
    return ApiService.post("/coefficient/readiness/update", payload);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_COEFFICIENT_READINESS_START](state) {
    state.coefficientReadiness.isLoading = true;
  },
  [SET_COEFFICIENT_READINESS_YEARLY](state, data) {
    state.coefficientReadiness.yearly = data.items;
    state.coefficientReadiness.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
